<label class="form-control">
  <span class="form-control__label free-text-question__label"></span>
  <input class="text-field"
         [(ngModel)]="title"
         [disabled]="disabled"
         (change)="filterValue()"/>
</label>
